// extracted by mini-css-extract-plugin
export var iconAnim = "styles-module--iconAnim--2af36";
export var iconPreview = "styles-module--iconPreview--a06c6";